/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { IOTestBaseData } from './IOTestBaseData';
const IOTestDataParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['subDescription', /* #__PURE__ */ codecOptional(codecString), 'sub_description'],
]), IOTestBaseData);
export class IOTestData extends IOTestBaseData {
    static decode(input) {
        return IOTestDataParser.decode(input).map(res => new IOTestData(res));
    }
    static unsafeDecode(input) {
        return IOTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestDataParser.encode(data);
    }
    static schema() {
        return IOTestDataParser.schema();
    }
}
